import React, { useState, useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { DATA_SOURCE_NAME_MAP } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import ChartTypeTab from '@/pages/intelligence/components/ChartsComponents/ChartTypeTab';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import usePieCharts from '@/pages/intelligence/components/Chart/hooks/usePieCharts';
import { useIntl } from 'umi';
const NEWRELEASE = 'newrelease';

//每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Bar,
    setChartType,
    dateType = 'Month',
    titleNow = '',
    imageType,
    barSeriesData,
    yAxisFormatter, // y轴格式化函数
    // tooltipFormatter,// 悬浮窗轴格式化函数
    splitNumber = 4, // y轴显示个数
    isxLabelDate = true, //x轴label默认展示日期
    legendStyle = '',
    islowerGame,
    lowerGameTime,
    dateValue,
    isNodata,
    fetchParams,
    barOrPieData,
    barNameList,
    topChartsType,
    setSegmention,
    segmention,
    seriesData,
    xAxisData,
    createLegendsCustomMade,
    tableSelection,
    segmentListDatas = [],
    isHasSegmentChart,
    isHasSegmentChartIcon,
    setTitleNow,
  } = props;

  // console.log('NewReleaseVisualis', props);

  const dataSources = ['appannie'];
  const cardRef = useRef(null);
  const chartsInstance = useRef<any>(null);

  const [chartLoading, setChartLoading] = useState(true);

  const dataSourceNames = useMemo(() => {
    if (!Array.isArray(dataSources)) return [];
    return dataSources.map(item => DATA_SOURCE_NAME_MAP[item])
      .filter(item => item);
  }, [dataSources]);

  //获取柱状图hooks
  const {
    barOption,
  } = useBarCharts({
    seriesData: barSeriesData,
    setChartLoading,
    barOrPieData,
    titleNow: segmention,
    secondTitleRight: titleNow,
    dataSourceEachers: dataSourceNames,
    barNameList,
    topChartsType,
    cardWidth: cardRef?.current?.clientWidth,
    imageType,
    startDate: fetchParams?.start_release_time,
    endDate: fetchParams?.end_release_time,
    ifNeedSourceImg: true,
  });

  // 获取折线图hooks
  const {
    lineOption
  } = useLineCharts({
    lineXAxisData: xAxisData,//x轴 label 数据
    lineSeriesData: seriesData,// 折线 数据
    legendsCustomMade: createLegendsCustomMade, // 图例
    yAxisFormatter, // y轴格式化函数
    // tooltipFormatter,// 悬浮窗轴格式化函数
    splitNumber, // y轴显示个数
    isxLabelDate, //x轴label默认展示日期
    dateType,
    legendStyle,
    islowerGame,
    lowerGameTime,
    dateValue,
    titleNow,
    topChartsType,
    imageType,
  });

  //获取饼图hooks
  const {
    pieOption
  } = usePieCharts({
    pieTitle: titleNow,
    tableSelection,
    dataSourceEachers: [''],
    topChartsType,
    chartsInstance,
    chartLoading,
    chartType,
    titleNow,
    startDate: fetchParams?.start_release_time,
    endDate: fetchParams?.end_release_time,
    metric: segmention,
  });

  const handleMetricChange = (value: string): void => {
    setSegmention(value);
    const segObj = segmentListDatas?.find((item: any) => item.value == value) || {};
    setTitleNow(segObj.text);

    if (topChartsType == NEWRELEASE && imageType == 'pc' && value !== 'Chart') {
      setChartType?.(ChartType.Bar);
    }
  };

  return (
    <>
      <div className="card-flex">
        <div className="card-title">
          {(isHasSegmentChart || isHasSegmentChartIcon) ? <ChartTypeTab
            defaultValue={segmention}
            selectType={imageType + topChartsType}
            sendSegment={handleMetricChange}
            isIconMetrics={isHasSegmentChartIcon}
          /> : null}
          {/* <ArrowdownText isNew={true} sortedData={sortByName} order={fetchParams.order} /> */}
        </div>
      </div>

      <div className="card-line" ref={cardRef}>
        <ChartsIndex
          ref={chartsInstance}
          chartLoading={chartLoading}
          barOption={barOption}
          lineOption={lineOption}
          pieOption={pieOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
